import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { PlaceOrderViewModel, ComputeOrderViewModel, ProcessStatus, CancelPendingTransactionBindingModel, VerifyPendingTransactionBindingModel, ComputeOrderBindingModel, Item, Payment, SetTransactionAsPaidOnlineBindingModel, CommitPaymentBindingModel, PlaceOrderBindingModel, DownloadGiftVoucherBindingModel, SendTransactionToEmailBindingModel } from 'src/app/api/models/web-booking.models';
import { RequestType } from 'src/app/api/services/base.service';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';
import { GiftVoucherOptionType, InvoiceDetailType, PaymentTypeGroup, PendingTrasactionStatus } from 'src/app/misc/enums';

declare let paypal: any;

@Component({
  selector: 'app-gift-voucher-checkout',
  templateUrl: './gift-voucher-checkout.component.html',
  styleUrls: ['./gift-voucher-checkout.component.scss']
})
export class GiftVoucherCheckoutComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  showPayButton = false;
  pendingTransaction: PlaceOrderViewModel = new PlaceOrderViewModel();
  order!: PlaceOrderViewModel;
  computed!: ComputeOrderViewModel;

  // PopUp
  public win: any;
  public cFrame: any;
  public iframe: any;
  public description = 'Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.';
  public showPopUp = false;
  public responseInitializePaymentCount = 0;
  public responseWorldPayCount = 0;
  public responseInitializePaymentReadyCount = 0;
  public paymentInProgress = false;

  timer: any;

  public disableCancellation = false;
  public monitoringCounter = 0;

  public showPayPal = true;

  public acceptTerms: boolean = false;

  ngOnInit() {
    this.app.loadingDescription = 'Loading...';
    this.app.pageTitle = '';
  }

  ngAfterViewInit(): void {
    this.baseTriggerChild.subscribe(() => {
      this.app.pageTitle = this.app.config.page3Header;

      if (this.app.customer == null) {
        this.showInfoMessage('Please login to continue');
        this.app.storageService.setItem(AppConstants.RedirectState, AppConstants.RouteCheckout);
        this.app.router.navigate([AppConstants.RouteLogin]);
        this.app.spinner.hide();
        return;
      }

      if (this.app.stringService.isEmpty(this.app.customer.firstName)) {
        this.app.spinner.hide();
        this.app.loadingDescription = 'Loading...';
        this.showErrorMessage('Your First Name is invalid, update your First Name and click update button to continue.');
        this.app.addLogs('Checkout', 'Required to update first name.');
        this.redirectToUpdateProfile();
        return;
      }

      if (this.app.stringService.isEmpty(this.app.customer.lastName)) {
        this.app.spinner.hide();
        this.app.loadingDescription = 'Loading...';
        this.showErrorMessage('Your Last Name is invalid, update your Last Name and click update button to continue.');
        this.app.addLogs('Checkout', 'Required to update last name.');
        this.redirectToUpdateProfile();
        return;
      }

      this.computeOrder();
      this.app.reCompute();
    });

    this.start();
  }

  ngOnDestroy(): void {
    this.baseTriggerChild.unsubscribe();
    this.app.cartUpdateTrigger.unsubscribe();
  }

  back(requestType?: RequestType) {
    this.app.loadingDescription = 'loading...';
    this.cancelPendingTransaction(requestType);
    this.app.storageService.removeItem(AppConstants.GiftVoucherPendingTransactionHeader);
    this.app.storageService.setItem(AppConstants.GiftVoucherProcessStatus, ProcessStatus.SelectGiftVoucher.toString());
    this.app.router.navigate([AppConstants.RouteGiftVouchers]);
  }

  login() {
    this.app.storageService.setItem(AppConstants.RedirectState, AppConstants.RouteCheckout);
    this.app.router.navigate([AppConstants.RouteLogin]);
  }
  
  gotoHome() {
    this.app.router.navigate([AppConstants.RouteSelectConsultation]);
  }

  gotoVoucher() {
      this.app.router.navigate([AppConstants.RouteGiftVouchers]);
  }

  // #region Paypal Button
  createPayPalButton(): void {
    let clientId: string = '';
    if (this.app.config.payPalPaymentMode === 'sandbox') {
      clientId = this.app.config.payPalSandboxCliendId;
    }
    else if (this.app.config.payPalPaymentMode === 'production') {
      clientId = this.app.config.payPalProductionCliendId;
    }
    this.loadExternalScript('https://www.paypal.com/sdk/js?currency=' + this.app.config.payPalCurrencyCode + '&client-id=' + clientId);
  }

  loadExternalScript(scriptUrl: string): any {
    const scriptElement = document.createElement('script');
    scriptElement.src = scriptUrl;
    scriptElement.addEventListener('load', () => {
      this.loadPayPalSmartPaymentButton();
    });
    scriptElement.addEventListener('error', (e) => {
      this.showErrorMessage('PayPal online payment loading failed.');
      this.showPayPal = false;
    });
    document.body.appendChild(scriptElement);
    setTimeout(() => {
      this.app.spinner.hide();
    }, 3000);
  }

  loadPayPalSmartPaymentButton(): void {
    paypal.Buttons({
      style: {
        layout: 'horizontal',
        tagline: false
      },
      onClick: (data: any, actions: any) => {
        if (this.acceptTerms && this.app.hasBookingItem) {
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.ConfirmAppointment.toString());
          this.disableCancellation = true;
          return true;
        }
        else if(this.app.hasBookingItem) {
          this.showErrorMessage('Please accept the Terms of Use to continue.');
          return false;
        }
        return true;
      },
      createOrder: (data: any, actions: { order: { create: (arg0: { purchase_units: { amount: { value: number; }; }[]; }) => any; }; }) => {
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: this.order.onlinePaymentAmountToBePaid
            }
          }]
        });
      },

      onApprove: (data: { orderID: string; }, actions: { order: { capture: () => Promise<any>; }; }) => {
        // cset trabsaction as paid online
        const model = {
          customerId: this.app.customer.customerId,
          pendingTransactionId: this.order.pendingTransactionId,
          onlinePaymentTransactionNo: data.orderID
        };
        this.order.onlineOrderId = data.orderID;
        this.app.storageService.setItem(AppConstants.PendingTransaction, JSON.stringify(this.order));
        this.app.webGiftVoucherService.SetTransactionAsPaidOnline(model).subscribe(
          () => {
            // check if appointment is expired.
            this.app.spinner.show();

            // proceed paypal payment
            return actions.order.capture().then(
              (              payment: { id: string; }) => {               
                // Show a success message to your buyer
                this.app.ngZone.run(() => {
                  this.commitPayment(payment.id);
                });
              },
              (              error: any) => {
                this.showErrorMessage(error);
                this.app.spinner.hide();
                return;
              });
          },
          error => {
            this.cancelPendingTransaction();
            this.showErrorMessage(error);
            this.app.spinner.hide();
          });
      },

      onCancel: (data: any, actions: any) => {
        return;
      },

      onError: (data: any, actions: any) => {
        return;
      }
    }).render('#paypal-button-container');
  }
  //#endregion
 
  // #region Pending Transaction
  cancelPendingTransaction(
    requestType?: RequestType,
    reloadPage?: boolean,
    recreatePending: boolean = false) {
    const pHeader = JSON.parse(this.app.storageService.getItem(AppConstants.GiftVoucherPendingTransactionHeader)) as PlaceOrderViewModel;
    if (this.app.stringService.isEmpty(pHeader) || this.app.stringService.isEmpty(pHeader.pendingTransactionId)) {
      return;
    }
    const model: CancelPendingTransactionBindingModel = new CancelPendingTransactionBindingModel();
    model.customerId = this.app.customer.customerId;
    model.pendingTransactionId = pHeader.pendingTransactionId;
    this.app.storageService.removeItem(AppConstants.GiftVoucherPendingTransactionHeader);
    this.app.webBookingService.CancelPendingTransaction(model, requestType).subscribe(
      () => {
        this.app.spinner.hide();
        if (reloadPage) {
          location.reload();
        }
        if (recreatePending) {
          this.computeOrder();
        } else {
          this.app.spinner.hide();
        }
      },
      () => {
        this.app.spinner.hide();
      },
    );
  }

  verifyPendingTransaction() {
    const model: VerifyPendingTransactionBindingModel = new VerifyPendingTransactionBindingModel();
    model.pendingTransactionId = this.order.pendingTransactionId;
    model.customerId = this.app.customer.customerId;
    this.app.webBookingService.VerifyPendingTransaction(model)
      .subscribe(
        () => {
          this.app.spinner.hide();
          this.computeOrder();
        },
        () => {
          this.app.spinner.hide();
          this.computeOrder();
        });
  }

  computeOrder() {
    this.app.spinner.show();
    if (this.app.basketItems == null || this.app.basketItems.length === 0) {
      this.app.router.navigate([AppConstants.RouteGiftVouchers]);
      this.app.spinner.hide();
      return;
    }

    const model: ComputeOrderBindingModel = new ComputeOrderBindingModel();
    model.branchId = this.app.branch.branchId;
    model.customerId = this.app.customer.customerId;
    model.items = this.app.basketItems;
    const payment: Payment = new Payment();
    payment.paymentTypeGroupId = PaymentTypeGroup.Web;
    model.payments = [];
    model.payments.push(payment);

    for (let a = 0; a < this.app.basketItems.length; a++) {
      if (this.app.basketItems[a].originalFee > this.app.basketItems[a].depositAmount) {
        model.enableDepositRequired = true;
      }
    }

    this.app.webBookingService.ComputeOrder(model)
      .subscribe(
        (data) => {
          this.computed = data;
          this.showPayButton = true;
          this.app.storageService.setItem(AppConstants.GiftVoucherPendingTransactionHeader, JSON.stringify(data));
          this.scrollTo();
          this.app.spinner.hide();
          this.placeOrder();
        },
        (error) => {
          this.showPayButton = false;
          this.showErrorMessage(error);
          this.app.spinner.hide();
        });
  }

  redirectToUpdateProfile() {
    this.baseTriggerChild.unsubscribe();
    this.app.router.navigate([AppConstants.RouteProfile]);
    this.app.storageService.setItem(AppConstants.RedirectState, AppConstants.RouteCheckout);
  }

  placeOrder() {
    this.app.loadingDescription = 'Please do not hit on Refresh or the Back button we are currently processing your transaction.';
    const model: PlaceOrderBindingModel = new PlaceOrderBindingModel();
    model.branchId = this.app.branch.branchId;
    model.customerId = this.app.customer.customerId;
    model.items = this.app.basketItems;

    for (let a = 0; a < this.app.basketItems.length; a++) {
      if (this.app.basketItems[a].originalFee > this.app.basketItems[a].depositAmount) {
        model.enableDepositRequired = true;
      }
    }

    const payment: Payment = new Payment();
    payment.paymentTypeGroupId = PaymentTypeGroup.Web;
    model.payments = [];
    model.payments.push(payment);
    this.app.webBookingService.PlaceOrder(model)
      .subscribe(
        (data) => {
          this.order = data;
          this.createPayPalButton();
        },
        (error) => {
          const message = this.getBadRequest(error);
          if(message == 'Transaction timeout.'){

            var newList: Item[] = [];
            this.app.basketItems.forEach((e, i) => {
              if(e.invoiceDetailType == InvoiceDetailType.Service)
              {
                this.app.cancelAppointment(e.appointmentId);
              }
              else
              {
                newList.push(e);
              }
            });
            this.showErrorMessage("Appointment in your cart has been expired. Please retry to book.");

            this.app.basketItems = newList;
            this.app.reCompute();
            this.computeOrder();            
          }
          else{
            this.showErrorMessage(error);
          }
        });
  }
  
  redirectToGiftVoucherRedemption(): void {
    if (this.acceptTerms !== true) {
      this.showErrorMessage('Please accept the Terms of Use to continue.');
      return;
    }
    this.app.router.navigate([AppConstants.RouteGiftVoucherRedemption]);
  }
  
  commitPayment(onlinePaymentId: string) {
    const commitPaymentBindingModel = {
      customerId: this.app.customer.customerId,
      onlinePaymentTransactionId: onlinePaymentId,
      pendingTransactionId: this.order.pendingTransactionId,
    };
    this.app.webGiftVoucherService.CommitPayment(commitPaymentBindingModel)
      .subscribe(
        data => {
          this.downLoadGiftVoucher(this.order.pendingTransactionId, this.app.customer.customerId);
        },
        error => {
          this.showErrorMessage(error);
          this.app.spinner.hide();
        });
  }

  downLoadGiftVoucher(pendingTransactionId: string, customerId: string) {
    const model = new DownloadGiftVoucherBindingModel();
    model.customerId = customerId;
    model.pendingTransactionId = pendingTransactionId;
    model.token = JSON.parse(this.app.storageService.getItem(AppConstants.Token)).access_token;
    this.app.webGiftVoucherService.DownloadGiftVoucher(model)
      .subscribe((data) => {
        this.paymentInProgress = false;
        this.app.storageService.setItem(AppConstants.GiftVoucherUrls, JSON.stringify(data));  
        this.app.webBookingService.SendTransactionToEmail(model).subscribe();
        this.saveAppointmentResult();
        this.app.spinner.hide();
      }, (error) => {
        this.app.spinner.hide();     
        this.app.addLogs('Download GV', error);
        this.app.storageService.setItem(AppConstants.GiftVoucherProcessStatus, ProcessStatus.Result.toString());
        this.paymentInProgress = false;
        this.app.showErrorMessage(error);
        this.app.router.navigate([AppConstants.RouteInvalid]);   
      });
  }

  saveAppointmentResult(): void {    
    this.app.storageService.setItem(AppConstants.BookingTreatmentResult, JSON.stringify(this.app.basketItems));
    this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.Result.toString());
      
    this.app.storageService.removeItem(AppConstants.Appointment);
    this.app.storageService.removeItem(AppConstants.RedirectState);
    this.app.storageService.removeItem(AppConstants.PendingTransaction);
    this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
    this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
    this.app.storageService.removeItem(AppConstants.SelectedPractitioner);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
    this.app.storageService.removeItem(AppConstants.BookingGiftVoucherNumber);
    this.app.storageService.removeItem(AppConstants.GiftVoucherSelectedVouchers);
    this.app.storageService.removeItem(AppConstants.GiftVoucherPendingTransactionHeader);  
    
    this.app.basketItems = [];  
    this.app.reCompute();
    this.app.router.navigate([AppConstants.RouteGvThankYou]);
  }
  // #endregion

  // #region Pay At the Appointment  
  confirmAppointment(): void {
    if (this.acceptTerms !== true) {
      this.showErrorMessage('Please accept the Terms of Use to continue.');
      return;
    }    
    const ids = [];
    for (const appointment of this.app.basketItems) {
      ids.push(appointment.appointmentId);
    }
    const m = {
      appointmentIds: ids,
      branchId: this.app.branch.branchId,
      customerId: this.app.customer.customerId,
      isSecured: false,
      externalGiftVoucherNumber: "",
      holdAmount: 0,      
      token: JSON.parse(this.app.storageService.getItem(AppConstants.Token)).access_token
    };
    this.app.spinner.show();
    this.app.webBookingService.ConfirmAppointment(m)
      .subscribe(
        data => {
          this.saveAppointmentResult(); 
          this.app.router.navigate([AppConstants.RouteGvThankYou]);
          this.app.spinner.hide();
        },
        error => {
          this.app.spinner.hide();     
          this.app.addLogs('Confirm Appointment', error);
          this.app.storageService.setItem(AppConstants.GiftVoucherProcessStatus, ProcessStatus.Result.toString());
          this.paymentInProgress = false;
          this.app.showErrorMessage(error);
          this.app.router.navigate([AppConstants.RouteInvalid]);   
        });
  }
  // #endregion

}
